import type { RouteLocationNormalized, RouteParams } from "vue-router";

import { Schulform } from "@core/asd/types/schule/Schulform";
import type { DeveloperNotificationException } from "@core/core/exceptions/DeveloperNotificationException";
import { BenutzerKompetenz } from "@core/core/types/benutzer/BenutzerKompetenz";
import { ServerMode } from "@core/core/types/ServerMode";

import type { NotenmodulMailProps } from "~/components/notenmodul/NotenmodulMailProps";
import { routeError } from "~/router/error/RouteError";
import { RouteNode } from "~/router/RouteNode";

import { type RouteNotenmodulAdministration, routeNotenmodulAdministration } from "./RouteNotenmodulAdministration";

const NotenmodulMail = () => import("~/components/notenmodul/NotenmodulMail.vue");

export class RouteNotenmodulMail extends RouteNode<any, RouteNotenmodulAdministration> {

	public constructor() {
		super(Schulform.values(), [
			BenutzerKompetenz.NOTENMODUL_ADMINISTRATION,
		], "notenmodul.administration.mail", "mail", NotenmodulMail);
		super.mode = ServerMode.DEV;
		super.propHandler = (route) => this.getProps(route);
		super.text = "Mail";
		this.isHidden = (params?: RouteParams) => this.checkHidden(params);
	}

	protected checkHidden(params?: RouteParams) {
		try {
			const { id } = (params === undefined) ? { id: undefined } : RouteNode.getIntParams(params, ["id"]);
			if (id === -1) {
				return routeNotenmodulAdministration.getRouteDefaultChild({ id });
			}
			if ((id !== undefined) && !(routeNotenmodulAdministration.data.manager.getConnectionResponse(id)?.success ?? false)) {
				return routeNotenmodulAdministration.getRouteDefaultChild({ id });
			}
			return false;
		} catch (e) {
			return routeError.getSimpleErrorRoute(e as DeveloperNotificationException);
		}
	}


	public getProps(to: RouteLocationNormalized): NotenmodulMailProps {
		return {
			manager: () => routeNotenmodulAdministration.data.manager,
			serverConfig: () => routeNotenmodulAdministration.data.mapEnmServerConfigServer,
			setServerConfigElement: routeNotenmodulAdministration.data.wenomSetServerConfigElement,
			updateServerConnection: routeNotenmodulAdministration.data.wenomUpdateServerConnection,
		};
	}

}

export const routeNotenmodulMail = new RouteNotenmodulMail();
